import { Container } from "@mui/material";
import React, { useState } from "react";
import CustomTabs from "../../widgets/CustomTabs";
import {
  MdOutlineAccountBalanceWallet,
  MdOutlinePsychology,
  MdOutlinePermMedia,
  MdOutlinePhone,
  MdOutlineSms,
  MdOutlineEmail,
} from "react-icons/md";
import PageTitle from "../../widgets/PageTitle";
import AddCredit from "./AddCredit";
import { useParams } from "react-router-dom";

const CreditRecharge = () => {
  const { id } = useParams();
  const [currentGroup, setCurrentGroup] = useState(0);

  return (
    <Container sx={{ mt: 3 }}>
      <PageTitle>Recharge Area</PageTitle>
      <CustomTabs
        tabs={[
          {
            label: "Waba Credit",
            icon: (
              <MdOutlineAccountBalanceWallet
                size={18}
                style={{ transition: "all 0.3s" }}
              />
            ),
          },
          {
            label: "AI Credit",
            icon: (
              <MdOutlinePsychology
                size={18}
                style={{ transition: "all 0.3s" }}
              />
            ),
          },
          {
            label: "Rcs Media Credit",
            icon: (
              <MdOutlinePermMedia
                size={18}
                style={{ transition: "all 0.3s" }}
              />
            ),
          },
          {
            label: "Voice Call Credit",
            icon: (
              <MdOutlinePhone size={18} style={{ transition: "all 0.3s" }} />
            ),
          },
          {
            label: "SMS Credit",
            icon: <MdOutlineSms size={18} style={{ transition: "all 0.3s" }} />,
          },
          {
            label: "Email Credit",
            icon: (
              <MdOutlineEmail size={18} style={{ transition: "all 0.3s" }} />
            ),
          },
        ]}
        value={currentGroup}
        onChange={(e, newValue) => setCurrentGroup(newValue)}
        containerSx={{ width: "100%", my: 1 }}
      />
      {currentGroup === 0 && <AddCredit id={id} rechargeType={"WABA"} />}
      {currentGroup === 1 && <AddCredit id={id} rechargeType={"AI"} />}
      {currentGroup === 2 && <AddCredit id={id} rechargeType={"RCS Media"} />}
      {currentGroup === 3 && <AddCredit id={id} rechargeType={"Voice Call"} />}
      {currentGroup === 4 && <AddCredit id={id} rechargeType={"SMS"} />}
      {currentGroup === 5 && <AddCredit id={id} rechargeType={"Email"} />}
    </Container>
  );
};

export default CreditRecharge;
